import React, { useState } from 'react';
import './about.css';
import bgImage from '../../assets/bg.jpg';
import BtnSocial from '../../components/btnSocial/BtnSocial';
import PersonalCard from '../../components/PersonalCard/PersonalCard';

const About = () => {
  const [actualLanguage, setActualLanguage] = useState('English');

  const changeLanguage = () => {
    actualLanguage === 'English'
      ? setActualLanguage('Spanish')
      : setActualLanguage('English');
  };
  return (
    <>
      <main>
        <img src={bgImage} alt="bgImage" className="bgImage" />
        <div className="aboutContainer">
          <div>
            <button className="language" onClick={() => changeLanguage()}>
              {actualLanguage === 'English' ? 'ESP' : 'ENG'}
            </button>
          </div>
          <PersonalCard language={actualLanguage} />
          <BtnSocial />
        </div>
      </main>
    </>
  );
};

export default About;
